// Connectivity store. "Offline" = the browser says so OR the last request to
// our own origin failed at the network layer. Any successful response flips it
// back. One store so the top-bar sync pill, the offline strip, the local queue
// and the ErrorCard all agree.

type Listener = () => void;

let browserOnline = typeof navigator === 'undefined' ? true : navigator.onLine !== false;
let networkFailed = false;
let lastOnlineAt: number | null = browserOnline ? Date.now() : null;
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l());
}

export const onlineStore = {
  isOnline: (): boolean => browserOnline && !networkFailed,
  lastOnlineAt: (): number | null => lastOnlineAt,
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  /** A request reached the server (any HTTP status). */
  reportSuccess(): void {
    const was = onlineStore.isOnline();
    networkFailed = false;
    lastOnlineAt = Date.now();
    if (!was && onlineStore.isOnline()) emit();
  },
  /** A request failed before any HTTP response (TypeError: Failed to fetch). */
  reportNetworkFailure(): void {
    if (networkFailed) return;
    networkFailed = true;
    emit();
  },
  /** Test hook / manual override. */
  set(online: boolean): void {
    browserOnline = online;
    networkFailed = !online;
    if (online) lastOnlineAt = Date.now();
    emit();
  },
};

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    browserOnline = true;
    networkFailed = false;
    lastOnlineAt = Date.now();
    emit();
  });
  window.addEventListener('offline', () => {
    browserOnline = false;
    emit();
  });
}
